/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoResolveTicketInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type ExternalTicketShowResolveMutationVariables = {
    input: infoResolveTicketInput;
};
export type ExternalTicketShowResolveMutationResponse = {
    readonly infoResolveTicket: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ExternalTicketShowResolveMutation = {
    readonly response: ExternalTicketShowResolveMutationResponse;
    readonly variables: ExternalTicketShowResolveMutationVariables;
};



/*
mutation ExternalTicketShowResolveMutation(
  $input: infoResolveTicketInput!
) {
  infoResolveTicket(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoResolveTicketPayload",
    "kind": "LinkedField",
    "name": "infoResolveTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalTicketShowResolveMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalTicketShowResolveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6fffc598124fa9fade5565247af7e80",
    "id": null,
    "metadata": {},
    "name": "ExternalTicketShowResolveMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalTicketShowResolveMutation(\n  $input: infoResolveTicketInput!\n) {\n  infoResolveTicket(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '44f879ea3fa6e09439063772734103e4';
export default node;
